import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/atoms/select';
import { Input } from '@/components/atoms/input';

export type DataTableNumberOperator = 'eq' | 'gt' | 'lt' | 'gte' | 'lte';

const NUMBER_OPERATOR_LABELS: Record<DataTableNumberOperator, string> = {
  eq: '= Equal to',
  gt: '> Greater than',
  gte: '≥ At least',
  lt: '< Less than',
  lte: '≤ At most',
};

interface DataTableNumberFilterFieldProps {
  op: DataTableNumberOperator;
  value: string;
  onOpChange: (op: DataTableNumberOperator) => void;
  onValueChange: (value: string) => void;
  placeholder?: string;
}

export function DataTableNumberFilterField({
  op,
  value,
  onOpChange,
  onValueChange,
  placeholder = 'Amount',
}: DataTableNumberFilterFieldProps) {
  return (
    <div className="flex min-w-0 gap-2">
      <Select value={op} onValueChange={(value) => onOpChange(value as DataTableNumberOperator)}>
        <SelectTrigger className="h-9 w-36 shrink-0 text-sm">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {(Object.entries(NUMBER_OPERATOR_LABELS) as [DataTableNumberOperator, string][]).map(
            ([value, label]) => (
              <SelectItem key={value} value={value} className="text-sm">
                {label}
              </SelectItem>
            ),
          )}
        </SelectContent>
      </Select>
      <Input
        type="number"
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        placeholder={placeholder}
        className="h-9 min-w-0 text-sm"
      />
    </div>
  );
}
